/**
 * Exportação .xlsx de verdade (roadmap #16): cabeçalho em negrito, moeda
 * formatada, largura de coluna e filtro. A biblioteca (xlsx-js-style) só é
 * baixada no primeiro clique, para não pesar o carregamento do app.
 */
import { getRecLabel, getRecMonths } from './formato';

const CABECALHO = { font: { bold: true, color: { rgb: 'FFFFFF' } }, fill: { patternType: 'solid', fgColor: { rgb: '111827' } } };
const TOTAL     = { font: { bold: true }, fill: { patternType: 'solid', fgColor: { rgb: 'E5E7EB' } } };
const MOEDA     = '"R$" #,##0.00';

async function carregar() { const m = await import('xlsx-js-style'); return m.default || m; }

function montarAba(XLSX, linhas, { moeda = [], total = false } = {}) {
  const ws = XLSX.utils.json_to_sheet(linhas);
  const cols = Object.keys(linhas[0] || {});
  const cel = (r, c) => ws[XLSX.utils.encode_cell({ r, c })];
  cols.forEach((_, c) => { if (cel(0, c)) cel(0, c).s = CABECALHO; });
  for (let r = 1; r <= linhas.length; r++) {
    for (const nome of moeda) {
      const c = cols.indexOf(nome); const x = c >= 0 && cel(r, c);
      if (x && typeof x.v === 'number') x.z = MOEDA;
    }
    if (total && r === linhas.length) cols.forEach((_, c) => { if (cel(r, c)) cel(r, c).s = { ...(cel(r, c).s || {}), ...TOTAL }; });
  }
  ws['!cols'] = cols.map(c => ({ wch: Math.min(42, Math.max(c.length + 2, ...linhas.slice(0, 300).map(l => String(l[c] ?? '').length + 2))) }));
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: Math.max(0, linhas.length - (total ? 1 : 0)), c: cols.length - 1 } }) };
  return ws;
}

/** abas: [{ nome, linhas, moeda?: [colunas], total?: bool }] */
export async function exportarXLSX(nome, abas) {
  const uteis = abas.filter(a => a.linhas?.length);
  if (!uteis.length) { alert('Nada para exportar.'); return; }
  const XLSX = await carregar();
  const wb = XLSX.utils.book_new();
  for (const a of uteis) XLSX.utils.book_append_sheet(wb, montarAba(XLSX, a.linhas, a), a.nome.slice(0, 31));
  XLSX.writeFile(wb, `${nome}-${new Date().toISOString().slice(0, 10)}.xlsx`);
}

/** Planilha de clientes fechados com repasses e comissão paga. */
export function linhasFechados(leads) {
  const fechados = leads.filter(l => l.stage === 'fechado');
  const d = (s) => s ? new Date(s + 'T00:00:00').toLocaleDateString('pt-BR') : '';
  const linhas = fechados.map(l => {
    const [p1, p2] = l.partners || []; const v = Number(l.value) || 0;
    const pv = (p) => p ? v * (Number(p.commission_rate) || 0) / 100 : 0;
    return {
      Empresa: l.company_name || '', 'Valor mensal': v,
      Tipo: (!l.recurrence || l.recurrence === 'unica') ? 'Avulso' : 'Contínuo',
      Duração: l.recurrence && l.recurrence !== 'unica' ? `${getRecMonths(l.recurrence)}x · ${getRecLabel(l.recurrence)}` : 'Único',
      'Parceiro 1': p1?.name || '', '% P1': p1 ? Number(p1.commission_rate) || 0 : '', 'Pagar P1/mês': p1 ? pv(p1) : '', 'Pago P1': p1 ? (p1.paid_at ? d(p1.paid_at) : 'a pagar') : '',
      'Parceiro 2': p2?.name || '', '% P2': p2 ? Number(p2.commission_rate) || 0 : '', 'Pagar P2/mês': p2 ? pv(p2) : '', 'Pago P2': p2 ? (p2.paid_at ? d(p2.paid_at) : 'a pagar') : '',
      'Total repasse/mês': pv(p1) + pv(p2),
      Cobrança: l.billing_active === false ? 'pausada' : 'ativa', Contrato: l.contract_paused ? 'pausado' : 'ativo',
      Assinado: l.contract_signed ? d(l.contract_signed_date) || 'sim' : '',
    };
  });
  if (linhas.length) {
    const soma = (k) => linhas.reduce((s, x) => s + (Number(x[k]) || 0), 0);
    linhas.push({ Empresa: `TOTAL (${linhas.length})`, 'Valor mensal': soma('Valor mensal'), 'Pagar P1/mês': soma('Pagar P1/mês'), 'Pagar P2/mês': soma('Pagar P2/mês'), 'Total repasse/mês': soma('Total repasse/mês') });
  }
  return linhas;
}

export const exportarFechadosXLSX = (leads) =>
  exportarXLSX('clientes-fechados', [{ nome: 'Fechados', linhas: linhasFechados(leads), moeda: ['Valor mensal', 'Pagar P1/mês', 'Pagar P2/mês', 'Total repasse/mês'], total: true }]);
